/* global DOMParser */
import * as t from 'io-ts';
import { decodeWithDefault, hasNoExcess } from 'app/utils/ioTs';

export function parseAttributes <P extends t.Props>(input: string, tagAttributes: t.TypeC<P>) {
  const parser = new DOMParser();
  const elm = parser.parseFromString(input, 'text/html').body.firstElementChild;
  if (elm) {
    const tags: {[index: string]: unknown} = {};
    for (const attr of elm.attributes) {
      tags[attr.name] = attr.value;
    }
    return hasNoExcess(tagAttributes, tags) ? decodeWithDefault(tagAttributes, tags, null) : null;
  }
  return null;
}
